if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			if ( ! this.hasAttribute('data-empty-product' ) ) {

				this.productGallery = this.querySelector('.product-gallery');
				this.productSlider = this.getProductSlider();

				// Gallery thumbnails

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )
							elm.classList.add('active');
						elm.addEventListener('click',e=>{
							const productSlider = this.getProductSlider();
							if ( this.isProductSliderEnabled() && productSlider ) {
								productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								const fauxIndex = e.currentTarget.hasAttribute('data-faux-index') ? e.currentTarget.dataset.fauxIndex : e.currentTarget.dataset.index;
								const scrollTarget = this.productGallery.querySelector(`.product-gallery-item[data-faux-index="${fauxIndex}"]`);
								if ( scrollTarget ) {
									window.scrollTo({
										top: scrollTarget.offsetTop + this.offsetTop,
										behavior: 'smooth'
									});
									this.thumbnailNavigationHelper(e.currentTarget.dataset.fauxIndex);
								}
							}
							this._pauseAllMedia();
							//playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
						});
					})

					if ( this.productSlider ) {
						this.productSlider.addEventListener('change', e=>{
							this.thumbnailNavigationHelper(e.target.index);
						});
					}

				}

				if ( this.productSlider ) {
					this.productSlider.addEventListener('change', e=>{
						const galleryItem = this.getGalleryItemByIndex(e.target.index);
						if ( galleryItem?.dataset.productMediaType == 'model' && this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', galleryItem.dataset.mediaId);
						}
						if ( galleryItem ) {
							this._pauseAllMedia();
							this.thumbnailNavigationHelper(e.target.index);
						}
					});
				}

			// Complete ritual variant map — parsed before variant handler fires
			const variantMapScript = this.querySelector('[data-complete-ritual-variant-map]');
			if (variantMapScript) {
				try {
					this.completeRitualVariantMap = JSON.parse(variantMapScript.textContent);
				} catch (e) {
					this.completeRitualVariantMap = null;
				}
			}

			// Product variant event listener for theme specific logic

			const productVariants = this.querySelector('product-variants');
			if ( productVariants ) {
				productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:productVariants});
			}

			// show cart drawer when element is added to cart

				if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

					let addToCartEnter = false;
					if ( this.querySelector('.product--add-to-cart-button') ) {
						this.querySelector('.product--add-to-cart-button').addEventListener('keyup', e=>{
							if ( e.keyCode == window.KEYCODES.RETURN ) {
								addToCartEnter = true;
							}
						})
					}

					if ( this.querySelector('.product--add-to-cart-form') ) {
						this.querySelector('.product--add-to-cart-form').addEventListener('add-to-cart', ()=>{
							document.getElementById('site-cart').show();
							if ( document.getElementById('cart-recommendations') ) {
								document.getElementById('cart-recommendations').generateRecommendations();
							}
							if ( addToCartEnter ) {
								setTimeout(()=>{
									document.querySelector('#site-cart .site-close-handle').focus();
								}, 200);
							}
						});
					}

			const completeRitualButton = this.querySelector('[data-complete-ritual-button]');
			if (completeRitualButton) {
				completeRitualButton.addEventListener('click', () => this.handleCompleteRitual(completeRitualButton));
			}

			}

				// Scroll navigation helper 

				if ( this.productGallery?.dataset.style == "scroll" ) {

					this.productGalleryNavigation = this.querySelector('.product-gallery__thumbnails');
					this.productGalleryNavigationItem = this.querySelectorAll('.product-gallery__thumbnails .thumbnail');

					const productGallerySlides = this.productGallery.querySelectorAll('.product-gallery-item');
					const reversedGallerySlides = [...productGallerySlides].reverse();

					const checkIfProductIsFirst = this.parentNode == document.querySelector('#main .mount-product-page:first-child') ? document.querySelector('#main .mount-product-page:first-child .product-gallery__thumbnails') : false;

					this.GALLERY_NAVIGATION_SCROLL = () => { 
						if ( ! this.isProductSliderEnabled() && window.innerWidth > 768 ) {

							for ( const slide of reversedGallerySlides ) {
								const slideTop = slide.getBoundingClientRect().top;
								if ( slideTop < window.innerHeight / 2 && slideTop > -window.innerHeight / 2  ) {
									this.productGalleryNavigationItem.forEach(elm=>elm.classList.remove('active'));
									this.productGalleryNavigationItem[slide.dataset.fauxIndex].classList.add('active');
									break;
								} 
							}

							const productGalleryTop = this.productGallery.getBoundingClientRect().top;
							if ( (productGalleryTop - window.innerHeight) * -1 > this.productGallery.offsetHeight ) {
								this.productGalleryNavigation.classList.add('scroll');
								this.productGalleryNavigation.classList.remove('scroll-up');
							} else if ( productGalleryTop > 0 ) {
								this.productGalleryNavigation.classList.add('scroll-up');
								this.productGalleryNavigation.classList.add('scroll');
								if ( checkIfProductIsFirst ) {
									checkIfProductIsFirst.style.height = `calc( var(--window-height) + ${window.scrollY}px )`;
								}
							} else if ( (productGalleryTop - window.innerHeight) * -1 < this.productGallery.offsetHeight ) {
								this.productGalleryNavigation.classList.remove('scroll');
								this.productGalleryNavigation.classList.remove('scroll-up');
							}

						}

					}

					window.addEventListener('scroll', this.GALLERY_NAVIGATION_SCROLL, {passive:true});
					this.GALLERY_NAVIGATION_SCROLL();

				}

				// Check for models

				const models = this.querySelectorAll('product-model');
				if ( models.length > 0 ) {
					window.ProductModel.loadShopifyXR();
					this.xrButton = this.querySelector('.product__view-in-space');
				}

				// Change sticky position for text content

				const productContentBox = this.querySelector('.box__product-content');
				const productGalleryBox = this.querySelector('.box__product-gallery');

				this.CONTENT_STICKY_RESIZE = () => {
					productContentBox.style.top = `calc(100vh - ${productContentBox.offsetHeight+1}px)`;
					productGalleryBox.style.top = `calc(100vh - ${productGalleryBox.offsetHeight+1}px)`;
				}
				window.addEventListener('resize', this.CONTENT_STICKY_RESIZE, {passive:true});
				this.CONTENT_STICKY_RESIZE();

				const contentObserver = new MutationObserver(mutations=>{
					for ( const mutation of mutations ) {
						this.CONTENT_STICKY_RESIZE();
					}
				});
				contentObserver.observe(productContentBox,{ attributes: true, childList: true, subtree: true });

				// Assist for video popups
				
				if ( this.productGallery.querySelector('video-popup') ) {
					
					const productVideoObserver = new MutationObserver(mutations=>{
						for ( const mutation of mutations ) {
							if ( mutation.target.classList.contains('video-opened') ) {
								this.productGallery.classList.add('remove-navigation');
							} else {
								this.productGallery.classList.remove('remove-navigation');
							}
						}
					});
					this.productGallery.querySelectorAll('video-popup').forEach(elm=>{
						productVideoObserver.observe(elm,{ attributes: true, childList: false, subtree: false });
					})

				}

			}

		}

		getProductSlider() {
			const slider = this.productGallery?.querySelector('css-slider') || this.querySelector('css-slider');
			if ( slider ) {
				this.productSlider = slider;
			}
			return slider || null;
		}

		getGalleryItemByIndex(index) {
			if ( index === undefined || index === null || index === '' ) {
				return null;
			}
			const itemIndex = parseInt(index, 10);
			if ( ! Number.isInteger(itemIndex) || itemIndex < 0 ) {
				return null;
			}
			const items = this.productGallery?.querySelectorAll('.product-gallery-item');
			if ( ! items?.length || itemIndex >= items.length ) {
				return null;
			}
			return items[itemIndex];
		}

		getGallerySlideIndex(galleryItem) {
			if ( ! galleryItem ) {
				return null;
			}
			const items = this.productGallery?.querySelectorAll('.product-gallery-item');
			if ( ! items?.length ) {
				return null;
			}
			const slideIndex = [...items].indexOf(galleryItem);
			return slideIndex >= 0 ? slideIndex : null;
		}

		isProductSliderEnabled() {
			return this.getProductSlider()?.sliderEnabled === true;
		}

		thumbnailNavigationHelper(index=0){
			if ( this.querySelector('.product-gallery__thumbnails') ) {
				this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
					if ( i == index )
						elm.classList.add('active');
					else 
						elm.classList.remove('active');
				});
				setTimeout(()=>{
					this.querySelector('.thumbnails-holder').scrollLeft = this.querySelector('.product-gallery__thumbnails .thumbnail.active').offsetLeft - this.querySelector('.product-gallery__thumbnails .thumbnail.active').offsetWidth;
				}, 50);
			}
		}

	updateCompleteRitualButton(variantId) {
		const button = this.querySelector('[data-complete-ritual-button]');
		if (!button || !this.completeRitualVariantMap) return;

		const variantData = this.completeRitualVariantMap.variants?.[String(variantId)];
		const source = variantData || this.completeRitualVariantMap.productDefault;
		if (source?.items?.length) {
			button.dataset.completeRitualItems = JSON.stringify(source.items);
			button.dataset.completeRitualDiscount = source.discount || '';
			button.removeAttribute('hidden');
		} else {
			button.dataset.completeRitualItems = '[]';
			button.dataset.completeRitualDiscount = '';
			button.setAttribute('hidden', '');
		}
	}

	onVariantChangeHandler(e){
		const variant = e.target.currentVariant;
		if (variant) {
			this.updateCompleteRitualButton(variant.id);
		}
		if ( variant && variant.featured_media != null ) {
				const variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
				if ( variantImg ) {
					const productSlider = this.getProductSlider();
					if ( productSlider && ( this.productGallery.dataset.style == "slider" || ( this.productGallery.dataset.style == "scroll" && this.isProductSliderEnabled() ) ) ) {
						const slideIndex = this.getGallerySlideIndex(variantImg);
						if ( slideIndex !== null ) {
							productSlider.changeSlide(slideIndex);
						}
					} else if ( productSlider ) {
						const originalOrder = [...this.productGallery.querySelectorAll('.product-gallery-item')].sort((a,b)=>{
							return a.dataset.index - b.dataset.index;
						});

						if ( Math.abs(this.productGallery.getBoundingClientRect().y) > window.innerHeight / 2 ) {
							window.scrollTo({
								top: this.productGallery.offsetTop,
								behavior: 'smooth'
							});
						}
						originalOrder.forEach(elm=>{
							productSlider.append(elm)
						})
						productSlider.prepend(variantImg);
						this.reorderThumbnailNavigation();
					}
				}
			}
		}

		reorderThumbnailNavigation(index){
			const reversedGallerySlidesForThumbnails = [...this.productGallery.querySelectorAll('.product-gallery-item')].reverse();
			const galleryThumbnailsHolder = this.querySelector('.product-gallery__thumbnails .thumbnails-holder .thumbnails');
			reversedGallerySlidesForThumbnails.forEach(slide=>{
				galleryThumbnailsHolder.prepend(this.querySelector(`.product-gallery__thumbnails .thumbnail[data-faux-index="${slide.dataset.index}"]`));
			})
			this.querySelectorAll('.product-gallery__thumbnails .thumbnails-holder .thumbnail').forEach((elm, i) => {
				elm.setAttribute('data-index', i);
			})
			this.thumbnailNavigationHelper(0);
			setTimeout(()=>{
				this.thumbnailNavigationHelper(0);
			}, 10);
		}

		_pauseAllMedia(){
			document.querySelectorAll('.product .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product video').forEach(video => video.pause());
			document.querySelectorAll('.product product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}

		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					media.querySelector('video').play();
					break;
				case 'external_video-youtube':
					media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					break;
				case 'external_video-vimeo':
					media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					break;
			}
		}

		async handleCompleteRitual(button) {
			try {
				const productFormElement = button.closest('product-form');
				const form = button.closest('form');
				if (!form) {
					return;
				}

				const selectedVariantInput = form.querySelector('input[name="id"]');
				if (!selectedVariantInput?.value) {
					return;
				}

				const quantityInput = form.querySelector('input[name="quantity"]');
				const selectedQuantity = Math.max(parseInt(quantityInput?.value || '1', 10) || 1, 1);

				const ritualItemsRaw = button.dataset.completeRitualItems;
				const ritualItems = JSON.parse(ritualItemsRaw || '[]');
				if (!Array.isArray(ritualItems) || ritualItems.length === 0) {
					return;
				}

				const items = [
					{ id: parseInt(selectedVariantInput.value, 10), quantity: selectedQuantity },
					...ritualItems.map(item => ({
						id: parseInt(item.id, 10),
						quantity: Math.max(parseInt(item.quantity, 10) || 1, 1)
					}))
				].filter(item => Number.isInteger(item.id) && item.id > 0);

				if (items.length === 0) {
					return;
				}

				button.classList.add('working');
				button.setAttribute('disabled', 'disabled');

				const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json'
					},
					body: JSON.stringify({ items })
				});

				if (!response.ok) {
					throw new Error('Failed to add ritual items');
				}

				const discountCode = (button.dataset.completeRitualDiscount || '').trim();
				if (discountCode) {
					// Apply discount cookie/session without interrupting add-to-cart flow.
					await fetch(`/discount/${encodeURIComponent(discountCode)}?redirect=/cart`, {
						method: 'GET',
						credentials: 'same-origin'
					});
				}

				if (typeof window.refreshCart === 'function') {
					window.refreshCart();
				} else if (productFormElement) {
					productFormElement.dispatchEvent(new CustomEvent('add-to-cart', { bubbles: true }));
				}
			} catch (error) {
				console.error('Complete ritual button error:', error);
			} finally {
				button.classList.remove('working');
				button.removeAttribute('disabled');
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}